<template>
  <action-dispatcher
    action="courses/getDetails"
    :parameters="$route.params.id"
    ref="coursesDispatcher"
  >
    <div class="view-course-details">
      <div class="container py-5">
        <h1 class="mb-4">{{ course.title }}</h1>
        <about :course="course" button-to-buy />
      </div>

      <section class="bg-white py-5">
        <div class="container">
          <h2 class="mb-4">Sobre o curso</h2>

          <div class="course-description" v-html="course.description" />
        </div>
      </section>

      <!-- <section class="py-5">
        <div class="container">
          <h2 class="mb-4">Cursos relacionados</h2>
          <div class="row">
            <div class="col-lg-3 col-md-6" v-for="i in 3" :key="i">
              <course-card />
            </div>
          </div>
        </div>
      </section> -->
    </div>
  </action-dispatcher>
</template>

<script>
// import CourseCard from "@/components/courses/CourseCard";
import About from "@/components/courses/About";
import { mapState } from "vuex";

export default {
  components: {
    // CourseCard,
    About
  },
  computed: {
    ...mapState("courses", ["course"])
  }
};
</script>

<style lang="scss" scoped>
.view-course-details {
  p,
  ul,
  ol {
    color: #979797;
    font-size: 16px;
    line-height: 24px;
  }

  .course-description {
    color: #979797;
  }
}
</style>
